import { useEffect } from 'react';
import { scrollTop } from '../../helpers/scrollTop';
import './PrivacyPolicy.scss';

export const PrivacyPolicyCOM = () => {
  useEffect(() => {
    scrollTop();
  });
  return (
    <section className="policy">
      <div className="_container policy__container">
        <h1 className="policy__title title">Privacy Policy</h1>
        <div className="rich-text-block-2 w-richtext">
          <p>
            <strong>SIXTIX Privacy Policy</strong>
          </p>
          <p> &nbsp;</p>
          <p>
            <strong>Last Updated: 01-11-2024</strong>
          </p>
          <p> </p>
          <p>
            <strong>Introduction</strong>
          </p>
          <p> </p>
          <p>
            This Privacy Policy explains how SIXTIX doo. (&quot;SIXTIX&quot;,
            &quot;we&quot;, &quot;us&quot;) collects, uses, shares, and protects
            your personal data in compliance with the General Data Protection
            Regulation (GDPR) and other relevant European data protection laws.
            This policy applies to all users of our website, services, and
            applications.
          </p>
          <p> </p>
          <p>
            <strong>1. Who We Are</strong>
          </p>
          <p> </p>
          <p>
            SIXTIX trade name of SIXTIX doo., located at Humska 1, 11000,
            Beograd (Savski Venac), Serbia, responsible for collecting and
            processing your personal data. SIXTIX is an international ticketing
            company operating across multiple countries, including the
            Netherlands, Serbia, Croatia, Roemania, France, Spain, Italy,
            Belgium, Germany and Austria.
          </p>
          <p>
            For any inquiries regarding the use of your personal data, you can
            reach our Data Protection Officer at{' '}
            <a href="mailto:support@sixtix.com">support@sixtix.com</a> .
          </p>
          <p> </p>
          <p>
            <strong>2. When Does This Privacy Policy Apply?</strong>
          </p>
          <p> </p>
          <p>
            This Privacy Policy applies to the personal data collected when you:
          </p>
          <p>• Visit our website or use our mobile application.</p>
          <p>• Purchase tickets through SIXTIX.</p>
          <p>• Contact our customer support team.</p>
          <p>• Interact with us through social media or email.</p>
          <p> </p>
          <p>
            <strong>3. What Data Do We Collect and How?</strong>
          </p>
          <p> </p>
          <p>We collect various types of personal data, including:</p>
          <p>
            • <strong>Identity and Contact Data</strong>: Name, address, email,
            phone number, date of birth.
          </p>
          <p>
            • <strong>Transaction Data</strong>: Ticket details, event
            preferences, payment details.
          </p>
          <p>
            • <strong>Website Use Data</strong>: IP address, device information,
            and browsing behavior collected via cookies and similar
            technologies.
          </p>
          <p>
            • <strong>Customer Support Data</strong>: Records of communication
            (emails, social media messages, phone calls).
          </p>
          <p>
            • <strong>Social Media Data</strong>: Information shared with us via
            linked accounts (e.g., Facebook, Google).
          </p>
          <p> </p>
          <p>
            <strong>4. How We Use Your Data</strong>
          </p>
          <p> </p>
          <p>We use your personal data for the following purposes:</p>
          <p>
            • <strong>Service Delivery</strong>: To provide ticketing services,
            including booking tickets and handling payments.
          </p>
          <p>
            • <strong>Customer Support</strong>: To assist with your inquiries
            or issues.
          </p>
          <p>
            • <strong>Marketing</strong>: To send you promotional offers
            tailored to your preferences, subject to your consent.
          </p>
          <p>
            • <strong>Fraud Prevention</strong>: To protect against unauthorized
            or fraudulent transactions.
          </p>
          <p>
            • <strong>Compliance</strong>: To fulfill our legal obligations
            under applicable laws and regulations.
          </p>
          <p> </p>
          <p>
            <strong>5. Legal Basis for Processing Your Data</strong>
          </p>
          <p> </p>
          <p>We process your personal data based on:</p>
          <p>
            • <strong>Performance of a Contract</strong>: To provide our
            services as per your agreement with us.
          </p>
          <p>
            • <strong>Legal Obligations</strong>: To comply with tax laws and
            other regulatory requirements.
          </p>
          <p>
            • <strong>Legitimate Interest</strong>: To improve our services,
            enhance user experience, and market products (with opt-out options).
          </p>
          <p>
            • <strong>Consent</strong>: For processing sensitive data or sending
            direct marketing messages (you can withdraw consent at any time).
          </p>
          <p> </p>
          <p>
            <strong>6. Sharing Your Data</strong>
          </p>
          <p> </p>
          <p>We share your data with:</p>
          <p>
            • <strong>Service Providers</strong>: Payment processors, IT
            support, and marketing agencies.
          </p>
          <p>
            • <strong>Event Organizers</strong>: To facilitate your access to
            events.
          </p>
          <p>
            • <strong>Legal Authorities</strong>: When required by law or in
            response to legal processes.
          </p>
          <p> </p>
          <p>
            <strong>7. International Data Transfers</strong>
          </p>
          <p> </p>
          <p>
            Your data may be transferred to partners outside of the European
            Economic Area (EEA). We ensure appropriate safeguards, such as EU
            Standard Contractual Clauses, are in place.
          </p>
          <p> </p>
          <p>
            <strong>8. Data Security</strong>
          </p>
          <p> </p>
          <p>
            We have implemented robust technical and organizational measures to
            protect your data against unauthorized access, alteration, or
            deletion. We regularly review our security practices to ensure your
            data remains secure.
          </p>
          <p> </p>
          <p>
            <strong>9. Data Retention</strong>
          </p>
          <p> </p>
          <p>
            We retain your personal data only for as long as necessary for the
            purposes outlined above or as required by law. Generally, we keep
            your data for up to 2 years after your last interaction with us.
          </p>
          <p> </p>
          <p>
            <strong>10. Your Rights</strong>
          </p>
          <p> </p>
          <p>You have the right to:</p>
          <p>
            • <strong>Access</strong> your data.
          </p>
          <p>
            • <strong>Correct</strong> inaccurate data.
          </p>
          <p>
            • <strong>Delete</strong> data (right to be forgotten).
          </p>
          <p>
            • <strong>Restrict Processing</strong> of your data.
          </p>
          <p>
            • <strong>Port</strong> your data to another provider.
          </p>
          <p>
            • <strong>Object</strong> to data processing for direct marketing.
          </p>
          <p>
            To exercise these rights, contact us at{' '}
            <a href="mailto:support@sixtix.com">support@sixtix.com</a> .
          </p>
          <p> </p>
          <p>
            <strong>11. Changes to This Privacy Policy</strong>
          </p>
          <p> </p>
          <p>
            We may update this Privacy Policy from time to time. Changes will be
            posted on this page, and we will notify you of significant updates
            via email.
          </p>
          <p>‍</p>
        </div>
        <div>
          <h1 className="policy__title title">Cookie Statement</h1>
          <div>
            <p>
              <strong>SIXTIX Cookie Statement</strong>
            </p>
            <p>
              <br />
              <strong>Last Updated: 01-11-2024</strong>
            </p>
            <p> </p>
            <p>
              <strong>Introduction</strong>
            </p>
            <p> </p>
            <p>
              This Cookie Statement explains how SIXTIX doo.
              (&quot;SIXTIX&quot;, &quot;we&quot;, &quot;us&quot;) uses cookies
              and similar technologies to provide, improve, and personalize our
              services. By using our website (www.sixtix.com), you consent to
              our use of cookies as described in this statement.
            </p>
            <p> </p>
            <p>
              <strong>1. What Are Cookies?</strong>
            </p>
            <p> </p>
            <p>
              Cookies are small text files that are stored on your device when
              you visit a website. They help the website remember your
              preferences and actions, making future visits more convenient.
              Cookies may also be used to provide personalized content, track
              website performance, and support advertising efforts.
            </p>
            <p> </p>
            <p>
              <strong>2. Types of Cookies We Use</strong>
            </p>
            <p> </p>
            <p>
              • <strong>Necessary Cookies</strong>: These cookies are essential
              for the operation of our website, allowing you to browse and use
              its features (e.g., secure login).
            </p>
            <p>
              • <strong>Functional Cookies</strong>: These cookies help us
              remember your preferences (e.g., language selection) and enhance
              your experience.
            </p>
            <p>
              • <strong>Performance Cookies</strong>: These cookies collect
              information about how you use our website, such as pages visited
              and links clicked. This helps us optimize our
              website&apos;sperformance.
            </p>
            <p>
              • <strong>Marketing and Tracking Cookies</strong>: We use these
              cookies to deliver ads relevant to you and measure the
              effectiveness of our marketing campaigns.
            </p>
            <p> </p>
            <p>
              <strong>3. Third-Party Cookies</strong>
            </p>
            <p> </p>
            <p>
              We use third-party cookies from partners such as Google, Facebook,
              and other advertising networks to help us analyze user behavior,
              deliver targeted advertising, and track conversions. These cookies
              are governed by the privacy policies of the third-party providers.
            </p>
            <p> </p>
            <p>
              <strong>4. Consent Management</strong>
            </p>
            <p> </p>
            <p>
              When you visit our website for the first time, you will be
              presented with a cookie banner asking for your consent to use
              non-essential cookies. You can accept all cookies or manage your
              preferences via the &quot;Cookie Settings&quot; link. You can
              modify your consent at any time.
            </p>
            <p> </p>
            <p>
              <strong>5. How to Manage Cookies</strong>
            </p>
            <p> </p>
            <p>
              You can manage or disable cookies through your browser settings.
              Please note that blocking some cookies may affect your ability to
              use certain features of our website. Below are links to help you
              manage cookies in popular browsers:
            </p>
            <p> </p>
            <p>
              • <strong>Google Chrome</strong>
            </p>
            <p>
              • <strong>Mozilla Firefox</strong>
            </p>
            <p>
              • <strong>Safari</strong>
            </p>
            <p>
              • <strong>Microsoft Edge</strong>
            </p>
            <p> </p>
            <p>
              <strong>6. Cookies Used by SIXTIX</strong>
            </p>
            <p> </p>
            <p>
              A detailed list of the specific cookies we use is available on our
              website, along with information about their purpose, duration, and
              type. This helps ensure transparency regarding our data collection
              practices.
            </p>
            <p> </p>
            <p> </p>
            <p>
              <strong>7. Changes to This Cookie Statement</strong>
            </p>
            <p> </p>
            <p>
              We may update this Cookie Statement periodically to reflect
              changes in technology, regulation, or our business practices. We
              will notify you of significant changes by posting the updated
              statement on our website.
            </p>
            <p> </p>
            <p>
              <strong>8. Contact Information</strong>
            </p>
            <p> </p>
            <p>
              If you have questions about our use of cookies, please contact us
              at <a href="mailto:support@sixtix.com">support@sixtix.com</a> .
            </p>
            <p>‍</p>
          </div>
        </div>
      </div>
    </section>
  );
};
